import { render, staticRenderFns } from "./the-pier.vue?vue&type=template&id=2ce02d0b"
import script from "./the-pier.vue?vue&type=script&lang=js"
export * from "./the-pier.vue?vue&type=script&lang=js"
import style0 from "./the-pier.vue?vue&type=style&index=0&id=2ce02d0b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports